import * as SDK from '@azure/communication-calling';
import axios from 'axios'; 
const startCaption = async (captionsCallFeature:SDK.CaptionsCallFeature) => {
    let teamsCaptions = captionsCallFeature.captions as SDK.TeamsCaptions;
        teamsCaptions.on('CaptionsReceived', captionsReceivedHandler);
          try {
            await teamsCaptions.startCaptions({ spokenLanguage: 'ar-sa'});
        } catch (e) {
            console.log("Error is ",e);
        }
};
const CloseCaptions = async ( call:any) => {
    let captionsCallFeature: SDK.CaptionsCallFeature = call.feature(SDK.Features.Captions);
    startCaption(captionsCallFeature);
};
let requestBody = {};
const captionsReceivedHandler : SDK.TeamsCaptionsHandler = (data: SDK.TeamsCaptionsInfo) => { 
    /** USER CODE HERE - E.G. RENDER TO DOM 
     * data.captionLanguage
     * data.captionText
     * data.resultType
     * data.speaker
     * data.spokenText  //console.log(data.spokenText);
     * data.timeStamp
    */
   if(data.spokenText.indexOf(".") !== -1 || data.spokenText.indexOf("?") !== -1){
    console.log(data.speaker.displayName," -- ", data.spokenText, "--", data.captionLanguage, "--", data.captionText);
    requestBody = {
     "sender":data.speaker.displayName, 
     "text": data.spokenText, 
     "on_call_status": true 
    } 

    const url ="https://leap-features-api.azurewebsites.net/v1/leap-feature";
    axios.post(url, requestBody ).then(response => {
     // alert(JSON.stringify(response));
     console.log("Message sent", response);
    }).catch(error => {
        console.log(error);
        
      //alert(JSON.stringify(error));
    })
}
}; 
export default CloseCaptions;